module.exports = __webpack_public_path__ + "img/mockup_market@2x.5f1d7fcd.png";